module.exports = __webpack_public_path__ + "img/SatisfiedActive.ddf9ca21.png";